import { useEffect } from 'react';

export default function InstagramCallback() {
  useEffect(() => {
    const code = new URLSearchParams(window.location.search).get('code');
    
    if (code) {
      // Send the auth code to the parent window
      window.opener?.postMessage({
        type: 'INSTAGRAM_AUTH_SUCCESS',
        code
      }, '*');
    }
    
    // Close this window after a short delay
    setTimeout(() => {
      window.close();
    }, 1000);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <p className="text-gray-600">Connecting to Instagram...</p>
    </div>
  );
}